export default __webpack_public_path__ + "static/media/corner.8db7fd6c.svg";